export default __webpack_public_path__ + "static/subscribe-content-illustration-dark-c0b29b16f14528a56414bb92e7664127.svg";